import { useEffect } from 'react';
import AuthService from '../services/AuthService';

export const useAuthExpiration = (onExpired: () => void) => {
  useEffect(() => {
    const checkExpiration = () => {
      if (AuthService.isTokenExpired() && AuthService.getToken()) {
        AuthService.logout();
        onExpired();
      }
    };

    // Verificar inmediatamente
    checkExpiration();

    // Verificar cada minuto
    const interval = setInterval(checkExpiration, 60000);

    return () => clearInterval(interval);
  }, [onExpired]);
};
